// Contrato de sincronizacion con el generador de PDF del backend.
//
// Puppeteer espera el selector [data-ready="true"] antes de capturar la pagina.
// El flag arranca en false y solo se marca cuando los datos ya fueron pintados,
// para que la captura nunca ocurra sobre una vista vacia. Si la carga falla el
// flag se queda en false a proposito: el backend agota su espera y responde con
// error, en lugar de entregar un PDF en blanco.
export default {
  data() {
    return {
      printReady: false
    };
  },
  methods: {
    markPrintReady() {
      this.$nextTick(() => {
        this.printReady = true;
      });
    }
  }
};
